import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core";
import { withSnackbar } from 'notistack';
import DataGrid from '@dataGrid'
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import GridConfig from "./gridConfig";
import styles from "../../styles";
import { compose } from "recompose";
import { getDataWithQueryString, postData } from "../../../../../api/componentAPIs";
import { isTimeValid } from '@dataGrid/gridUtilities';
import MESSAGES from "../../../../../appMessages";
import appConstants from "../../../../../appConstants";

class DriverPreferences extends React.PureComponent{
    constructor(props){
        super(props);
        this.gridConfig = new GridConfig();
        this.state = {
            driverData: null,
            showErrorMessage: appConstants.GRID_STATUS.LOADING,
        }
    }

    componentDidMount(){
        this.getDriverPreferenceData();
    }

    componentDidUpdate(prevProps){
        if( this.props.userData.userProfile.scenarioID !== prevProps.userData.userProfile.scenarioID){
            this.getDriverPreferenceData();
        }     
    }

    getDriverPreferenceData = () => {
        const { scenarioID } = this.props.userData.userProfile;
    
        if (!scenarioID) {
          this.setDriverPreferenceData(null, appConstants.GRID_STATUS.ERROR);
          return;
        }
    
        getDataWithQueryString('GetDriverPreferences', `scenarioId=${scenarioID}`).then(
          (response) => {
            if (response.status === 200) {
              this.setDriverPreferenceData(response.data, appConstants.GRID_STATUS.SUCCESS);
              return;
            }
            this.setDriverPreferenceData(null, appConstants.GRID_STATUS.ERROR);
          },
          (_error) => {
            this.setDriverPreferenceData(null, appConstants.GRID_STATUS.ERROR);
          }
        );
      };
    
    setDriverPreferenceData = (driverData, showErrorMessage) => {
        this.setState({
            driverData,
            showErrorMessage
        });
    };

    updateDriverPreferences = (params) => {
        const updateObject = {
            scenarioId: this.props.userData.userProfile.scenarioID,
            driverPreference:{
                ...params.data,
                [params.colDef.field]: params.newValue
            }
        }
        postData("UpdateDriverPreferences", updateObject).then(response => {
            if(Math.trunc(response.status/100) === 2){
                this.props.enqueueSnackbar(`${params.colDef.headerName} updated for zone ${params.data.preferredZone}`, {variant: "success"});
            } else {
               this.handleUpdateFailure({params, statusCode: response.status});
            }
        }, () =>{
            this.handleUpdateFailure({params});
        });
    }

    handleUpdateFailure = ({params, message, statusCode}) => {
        params.data[params.colDef.field] = params.oldValue;
        this.gridApi.refreshCells();
        if (statusCode === 403) {
            return;
        }
        message = message || `Failed to update ${params.colDef.headerName} for zone ${params.data.preferredZone}`;
        this.props.enqueueSnackbar(message, {variant: "error"});
    }

    onCellValueChanged = (params) =>{
        if(params.colDef.field === "startTime") {
            if(params.oldValue !== params.newValue){
                if(!params.newValue){
                    this.handleUpdateFailure({params, message: MESSAGES.DRIVER_PREF.STARTTIME_EMPTY});
                } else if(!isTimeValid(params.newValue)) {
                    this.handleUpdateFailure({params, message: MESSAGES.DRIVER_PREF.STARTTIME_INVALID});
                } else {
                    this.updateDriverPreferences(params);
                }              
            }
        }
    }

    onGridReady = ({api}) => {
        this.gridApi = api;
    }

    render(){
        const { classes } = this.props;
        const { driverData, showErrorMessage } = this.state;
        return(
            <Fragment>
                <header className={classes.moduleHeader}  data-automationid="driverPreferences-title"> Driver Preferences </header>
                <div className={classes.moduleContainer}>
                    <div className={`${classes.gridContainer} ${classes.parameterGridContainer}`}>
                        <div className={`${classes.dataGrid} ${classes.parameterGrid}`}>
                            <DataGrid
                                columnDefs={this.gridConfig.config.columns}
                                config={this.gridConfig.config}
                                defaultColDef={this.gridConfig.config.defaultColDef}
                                enableFilter={this.gridConfig.config.enableFilter}
                                rowData={driverData}
                                onGridReady={this.onGridReady}
                                onCellValueChanged={this.onCellValueChanged}
                                showErrorMessage={showErrorMessage}
                                getRowId={(params) => params.data.driverId}
                            />
                        </div>
                    </div>
                </div>
        </Fragment>

        )
    }
}

export default compose(withStyles(styles), withUserProfile, withSnackbar)(DriverPreferences)
